import { render } from "./Formulario.vue?vue&type=template&id=ec6fba6e"
import script from "./Formulario.vue?vue&type=script&lang=ts"
export * from "./Formulario.vue?vue&type=script&lang=ts"

import "./Formulario.vue?vue&type=style&index=0&id=ec6fba6e&lang=css"
script.render = render

export default script